import { Factory } from '../../services/Factory';
import { ProjectService } from '../../services/project/ProjectService';
import { AccountService } from '../../services/account/AccountService';
import { INotificationService } from '../../services/notification';

interface IReActivateControllerScope extends angular.IScope {
  project;
  closeModal: Function;
  startReActivation: Function;
  saving: boolean;
  authyToken: string;
}

export class ReActivateModalController {
  private $scope:IReActivateControllerScope;
  private $modalInstance;
  private $location;
  private project;
  private projectService: ProjectService;
  private accountService: AccountService;
  private notificationService: INotificationService;

  constructor($scope:IReActivateControllerScope, $modalInstance, $location, project, projectService: ProjectService, accountService: AccountService, notificationService: INotificationService) {
    this.$scope = $scope;
    this.$modalInstance = $modalInstance;
    this.$location = $location;
    this.project = project;
    this.accountService = accountService;
    this.projectService = projectService;
    this.notificationService = notificationService;

    this.$scope.closeModal = () => {
      this.$modalInstance.close();
    };

    this.$scope.startReActivation = () => {
      this.$scope.saving = true;

      projectService.Reactivate(this.project, this.$scope.authyToken, () => {
        this.$scope.saving = false;
        this.$modalInstance.close();

        this.notificationService.addSuccess({
          title: "Project re-activated successfully",
          description: this.project.name,
          timeout: 5000
        });

        $location.path('/project/' + this.project.id);

      }, (data) => {
        this.$scope.saving = false;
        this.notificationService.addError({
          title: "Unable to re-activate project",
          description: data,
          timeout: 5000
        });
      })

    };

    this.accountService.StartMFA();
  }
}

frontendApp.controller("ReActivateModalController", ["$scope", "$uibModalInstance", "$location", "project", "ProjectService", "AccountService", "NotificationService", Factory.Create(ReActivateModalController)]);